import { View, StyleSheet, StyleProp, ViewStyle } from "react-native";
import { RadioButton, RadioButtonProps } from "./RadioButton";

export interface RadioButtonGroupProps<T extends string> {
  options: T[];
  value?: T;
  onChange?: (value: T) => void;
  orientation?: "horizontal" | "vertical";
  disabled?: boolean;
  size?: RadioButtonProps["size"];
  style?: StyleProp<ViewStyle>;
  gap?: number;
}

export function RadioButtonGroup<T extends string>({
  options,
  value,
  onChange,
  orientation = "vertical",
  disabled = false,
  size = "medium",
  style,
  gap = 12,
}: RadioButtonGroupProps<T>) {
  return (
    <View
      style={[styles.container, orientation === "horizontal" ? styles.horizontal : styles.vertical, { gap }, style]}
    >
      {options.map((option) => (
        <RadioButton
          key={option}
          label={option}
          selected={value === option}
          onPress={() => onChange?.(option)}
          disabled={disabled}
          size={size}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {},
  horizontal: {
    flexDirection: "row",
    alignItems: "center",
  },
  vertical: {
    flexDirection: "column",
  },
});
